import React, { Component } from 'react';
import Navbar from '../../../_components/common/Navbar';
import { CommonBreadCrumb } from '../../../_components/common/CommonBreadCrumb';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { organisationAction } from '../../../_actions/organisation.action';
import { getBatchAction, getAssessementAction, sendRemainderAction, sendCustomMailAction } from '../../../_actions';
import Aux from '../../../_components/common/Hoc';
import CustomTableNew from '../../../_components/common/CustomTableNew';
import SettingsHead from '../../../_components/common/SettingsHead';
import { compareBy } from '../Organisation/component/CompareFunc';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input } from 'reactstrap';
import Page404 from '../../404page';
import { LoaderComp } from '../../../_components/common/LoaderComp/Loadercomp';



class CustomEmails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orgId: 'null',

            selId: null,
            value: '',
            showTable: false,
            assessmentData: '',
            buttonAssessmentData: [],
            modal: false,
            sendRemainderState: false,
            sendMailState: false,
            checkBoxData: [],
            reRenderSettingsHead: 1,
            paticipantListData: [],
            sortTypeAssessment: false,
            assessmentTableData: '',
            template: '',
            subject: '',
            message: '',
            subjectPlaceholder: '',
            messagePlaceholder: '',

            submitted: false,
            BatchId: null,

            hasProperOrgId: true,
            idLoader: true,
        }
    }



    sortBy(columnKey, type, tableName) {
        if (tableName === 'assessmentDataTable') {
            this.setState({ sortTypeAssessment: type })
            const arrayCopy = this.state.assessmentTableData === '' ? this.props.assessmentResponse : this.state.assessmentTableData;
            arrayCopy.sort(compareBy(columnKey, this.state.sortTypeAssessment));
            let formatedData = []
            arrayCopy.map(
                (data, i) => {
                    formatedData.push({
                        'instrument__instrument_name': [{
                            'instrument__instrument_name': data.instrument__instrument_name,
                            "instrument__instrument_image": data.instrument__instrument_image,
                        }],
                        'participant__email': data.participant__email,
                        'participant__short_name': data.participant__short_name,
                        'self': data.assessment_completed_count + "/" + data.assessment_number_count,
                        'respondents': data.respondent_completed + " of " + data.respondent_count + " completed",
                        'is_submited': data.is_submited === false ? 'No' : 'Yes',
                        'idString': `${data.id}`
                    })
                }
            )

            this.setState({ assessmentData: formatedData })
        }


    }
    componentDidMount() {
        this.props.dispatch(organisationAction.getOrganisation((callback_Data) => {
            const query = new URLSearchParams(this.props.location.search);
            const ids = {}
            for (let param of query.entries()) {
                ids[param[0]] = param[1];
            }

            if (Object.keys(ids).length > 0) {
                this.setState({
                    showTable: !!ids.organisation
                });
            }
            if (ids.organisation) {
                const selId = this.getSellerId(+ids.organisation);

                this.setState({
                    orgId: +ids.organisation,
                    BatchId: ids.batch === 'unalloted' ? null : +ids.batch,
                })
                const data = {
                    "batch_id": ids.batch === 'unalloted' ? null : +ids.batch,
                    "organisation_id": +ids.organisation
                }
                let hasId = false

                for (const element of callback_Data.data.organisation_list) {
                    if (element.id == ids.organisation) {
                        hasId = true;
                        this.props.dispatch(getAssessementAction.getAssessementHandler(data));
                        this.props.dispatch(getBatchAction.getBatchHandler(selId, +ids.organisation));
                        break; // Exit the loop once we've found the matching organization
                    }
                }

                this.setState({
                    hasProperOrgId: hasId,
                    idLoader: false
                })

            } else {
                this.setState({
                    hasProperOrgId: true,
                    idLoader: false
                })
            }
        }))
        this.setState(prevState => ({
            buttonAssessmentData: [
                {
                    id: 1,
                    heading: "SEND REMAINDER",
                    state: prevState.sendRemainderState,
                    toggler: this.sendRemainderToggle.bind(this),
                    disabled: 'disabled'
                },
                {
                    id: 2,
                    heading: "SEND CUSTOM MAIL",
                    state: prevState.sendMailState,
                    toggler: this.sendMailToggle.bind(this),
                    disabled: 'disabled'
                },
            ]
        }));


    }

    sendRemainderToggle(data) {
        this.setState({
            sendRemainderState: true
        })

    }

    sendMailToggle(data) {
        this.setState({
            sendMailState: true
        })

    }

    filterData(data, searchTerm) {
        let formatedData = []
        if (searchTerm !== '') {
            data.map(
                (data, i) => {
                    formatedData.push({
                        'instrument__instrument_name': [{
                            'instrument__instrument_name': data.instrument__instrument_name,
                            "instrument__instrument_image": data.instrument__instrument_image,
                        }],
                        'participant__email': data.participant__email,
                        'participant__short_name': data.participant__short_name,
                        'self': data.assessment_completed_count + "/" + data.assessment_number_count,
                        'respondents': data.respondent_completed + " of " + data.respondent_count + " completed",
                        'is_submited': data.is_submited === false ? 'No' : 'Yes',
                        'idString': `${data.id}`
                    })
                }
            )
        } else {
            this.props.assessmentResponse.map(
                (data, i) => {
                    formatedData.push({
                        'instrument__instrument_name': [{
                            'instrument__instrument_name': data.instrument__instrument_name,
                            "instrument__instrument_image": data.instrument__instrument_image,
                        }],
                        'participant__email': data.participant__email,
                        'participant__short_name': data.participant__short_name,
                        'self': data.assessment_completed_count + "/" + data.assessment_number_count,
                        'respondents': data.respondent_completed + " of " + data.respondent_count + " completed",
                        'is_submited': data.is_submited === false ? 'No' : 'Yes',
                        'idString': `${data.id}`
                    })
                }
            )

        }
        this.setState({
            assessmentData: formatedData
        });
    }
    toggleModal(showModal) {
        this.setState({
            modal: showModal
        });
    }

    getSellerId(id) {
        const { loading, organisationResponse } = this.props;

        if (loading === false) {
            for (let i in organisationResponse) {
                if (+organisationResponse[i].id === +id) {


                    return organisationResponse[i].seller__id;
                }
            }
        }



    }

    onChangeOrganisation = (ev) => {
        if (ev.target.value !== "null") {
            const selId = this.getSellerId(ev.target.value);
            const eventValue = ev.target.value

            this.setState({
                showTable: true,
                orgId: ev.target.value,

                selId: selId,
            }, () => {
                const queryParams = [];
                queryParams.push(encodeURIComponent('organisation') + '=' + encodeURIComponent(eventValue))
                queryParams.push(encodeURIComponent('batch') + '=' + encodeURIComponent('unalloted'))
                const queryString = queryParams.join('&');
                this.props.history.push({
                    search: '?' + queryString
                });
                this.props.dispatch(getBatchAction.getBatchHandler(selId, eventValue))
                const data = {
                    "batch_id": null,
                    "organisation_id": eventValue
                }
                this.props.dispatch(getAssessementAction.getAssessementHandler(data))
            });

        }
        if (ev.target.value === "null") {
            this.props.history.push({
                search: ''
            });
            this.setState({
                showTable: false,
                value: '',
            });
        }

    }

    onChangeBatch = (ev) => {
        let data = null;
        if (ev.target.value === "Unalloted") {
            const queryParams = [];
            queryParams.push(encodeURIComponent('organisation') + '=' + encodeURIComponent(this.state.orgId))
            queryParams.push(encodeURIComponent('batch') + '=' + encodeURIComponent('unalloted'))
            const queryString = queryParams.join('&');
            this.props.history.push({
                search: '?' + queryString
            });
            this.setState({
                BatchId: null
            })
            data = {
                "batch_id": null,
                "organisation_id": this.state.orgId
            }
        }
        else {
            const queryParams = [];
            queryParams.push(encodeURIComponent('organisation') + '=' + encodeURIComponent(this.state.orgId))
            queryParams.push(encodeURIComponent('batch') + '=' + encodeURIComponent(ev.target.value))
            const queryString = queryParams.join('&');
            this.props.history.push({
                search: '?' + queryString
            });
            data = {
                "batch_id": ev.target.value,
                "organisation_id": this.state.orgId
            }
            this.setState({
                BatchId: ev.target.value
            })
        }
        this.props.dispatch(getAssessementAction.getAssessementHandler(data))
    }

    toggle = () => {
        this.setState({
            sendRemainderState: false,
            sendMailState: false,
            subject: '',
            message: '',
            subjectPlaceholder: '',
            messagePlaceholder: '',
            template: '',
            submitted: false
        });
    }


    selectAllAssessment(data, clickToggle) {
        const { buttonAssessmentData } = this.state;
        if (clickToggle === true) {
            buttonAssessmentData.forEach(val => {
                if (val.disabled !== undefined) {
                    val.disabled = '';
                }
            });
            this.setState({
                reRenderSettingsHead: 2,
                assessmentResponse: data
            });
        } else {
            buttonAssessmentData.forEach(val => {
                if (val.disabled !== undefined) {
                    val.disabled = 'disabled';
                }
            });
            this.setState({
                reRenderSettingsHead: 1,
                assessmentResponse: data
            });
        }


    }



    getSelectedData(data) {


        if (data.length !== 0) {
            this.setState({ checkBoxData: data }, () => {
                this.selectAllAssessment(this.state.checkBoxData, true)
            })
        } else if (data.length === 0) {
            this.setState({ checkBoxData: data }, () => {
                this.selectAllAssessment(this.state.checkBoxData, false)
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.assessmentResponse !== this.props.assessmentResponse) {
            const formatedData = []
            this.props.assessmentResponse !== '' &&
                this.props.assessmentResponse.map(
                    (data, i) => {
                        formatedData.push({
                            'instrument__instrument_name': [{
                                'instrument__instrument_name': data.instrument__instrument_name,
                                "instrument__instrument_image": data.instrument__instrument_image,
                            }],
                            'participant__email': data.participant__email,
                            'participant__short_name': data.participant__short_name,
                            'self': data.assessment_completed_count + "/" + data.assessment_number_count,
                            'respondents': data.respondent_completed + " of " + data.respondent_count + " completed",
                            'is_submited': data.is_submited === false ? 'No' : 'Yes',
                            'idString': `${data.id}`
                        })
                    }
                )

            if (this.props.assessmentResponse !== '') {

                this.setState({
                    assessmentData: formatedData
                })
            }

        }

    }

    getAssessmentId = (type) => {
        const id = [];
        if (type === 'excludeSubmitted') {
            this.state.checkBoxData.forEach((data) => {
                if (data.is_submited === 'No') {
                    id.push(+data.idString);
                }
            });
        }
        if (type === 'includeSubmitted') {
            this.state.checkBoxData.forEach((data) => {
                id.push(+data.idString);
            });
        }
        return id;
    }

    onClickSendRemainder = () => {
        const fd = {
            'assessment_ids': this.getAssessmentId('excludeSubmitted')
        };
        this.props.dispatch(sendRemainderAction.sendRemainderHandler(fd, () => {
            this.props.dispatch(getAssessementAction.getAssessementHandler({
                batch_id: this.state.BatchId,
                organisation_id: this.state.orgId
            }));
            this.toggle();
        }));
    };

    isSubmitted = (checkBoxData, type) => {
        let submittedCount = 0;
        for (const item of checkBoxData) {
            if (item.is_submited === 'Yes') {
                submittedCount++;
            }
        }

        if (type === 'boolean') {
            return submittedCount > 0;
        }
        if (type === 'count') {
            return submittedCount;
        }
    }

    alreadySubmitted = (checkBoxData) => {
        for (const item of checkBoxData) {
            if (item.is_submited === 'No') {
                return true;
            }
        }
        return false;
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
        if (name === 'template') {
            if (value === '') {
                this.setState({
                    subject: '',
                    message: '',
                    subjectPlaceholder: '',
                    messagePlaceholder: ''
                });
            }
            if (value === 'temp1') {
                this.setState({
                    subject: '',
                    message: '',
                    subjectPlaceholder: 'Subject line - 1',
                    messagePlaceholder: 'Message Body - 1'
                });
            }
            if (value === 'temp2') {
                this.setState({
                    subject: '',
                    message: '',
                    subjectPlaceholder: 'Subject line - 2',
                    messagePlaceholder: 'Message Body - 2'
                });
            }
        }
    }

    handleSubmit = (e) => {
        this.setState({ submitted: true });

        const data = {
            'assessment_ids': this.getAssessmentId('includeSubmitted'),
            "subject": this.state.subject,
            "message": this.state.message,
            "organisation_id": this.state.orgId,
            "batch_id": this.state.BatchId
        };

        if (this.state.subject.trim().length > 0 && this.state.message.trim().length > 0) {
            this.setState({ sendCustomMailLoading: true });
            this.props.dispatch(sendCustomMailAction.sendCustomMailHandler(data, () => {
                this.props.dispatch(getAssessementAction.getAssessementHandler({
                    batch_id: this.state.BatchId,
                    organisation_id: this.state.orgId
                }));
                this.toggle();
            }));
        }
    };

    render() {

        const { organisationResponse, loading, batchListResponse, getBatchLoading, assessmentResponse } = this.props;

        const { template, submitted, subject, message } = this.state;






        const columns = [
            {
                id: 1,
                name: 'Type',
                key: 'instrument__instrument_name',
                type: 'logoText',
                sort: true,
                link: ''
            },
            {
                id: 2,
                name: 'PARTICIPANT',
                key: 'participant__email',
                sort: true,
                link: ''
            },
            {
                id: 3,
                name: 'SHORT NAME',
                key: 'participant__short_name',
                sort: false,
                link: ''
            },
            {
                id: 4,
                name: 'SELF',
                key: 'self',
                sort: false,
                link: ''
            }, {
                id: 5,
                name: 'RESPONDENTS',
                key: 'respondents',
                sort: false,
                link: ''
            }, {
                id: 6,
                name: 'SUBMITTED',
                key: 'is_submited',
                sort: false,
                link: ''
            },
        ];

        const settingsColumns = [
            {
                id: 1,
                name: 'Type',
                key: 'instrument__instrument_name',
                sort: true,
                link: ''
            },
            {
                id: 2,
                name: 'PARTICIPANT',
                key: 'participant__email',
                sort: true,
                link: ''
            },
            {
                id: 3,
                name: 'SHORT NAME',
                key: 'participant__short_name',
                sort: false,
                link: ''
            },

        ];


        const remainderModalBody = <div className="">
            <p className={this.isSubmitted(this.state.checkBoxData, 'boolean') ? ' mt-4 mb-0 text-center' : 'my-4 text-center'}>You have selected {this.state.checkBoxData.length} participant(s).</p>
            {
                this.isSubmitted(this.state.checkBoxData, 'boolean') && this.alreadySubmitted(this.state.checkBoxData) &&
                <p className="text-center"> The reminder will be sent only to {this.state.checkBoxData.length - this.isSubmitted(this.state.checkBoxData, 'count')} participant(s)</p>
            }
            {
                !this.alreadySubmitted(this.state.checkBoxData) &&
                <p className="text-center"><i className="fas fa-exclamation-triangle"></i>&nbsp;You cannot send a reminder as they have already submitted the assessment</p>
            }
            {
                this.state.checkBoxData.map((data, i) => (
                    <div key={i} className="mx-md-5 mx-1 d-flex flex-row" style={{ borderBottom: '1px solid black' }}>
                        <small className={data.is_submited === 'Yes' ? 'text-danger col-md-8 col-6 px-0' : 'text-success col-md-8 col-6 px-0'}>
                            {data.participant__email}
                        </small>
                        {data.is_submited === 'Yes' ? (
                            <small className="text-center col-md-4 col-6">Already Submitted</small>
                        ) : (
                            <small className="text-center col-md-4 col-6"><i className="fa fa-check-circle"></i></small>
                        )}
                    </div>
                ))
            }

        </div>



        return (
            <div >
                <Navbar />
                {
                    this.state.idLoader ?
                        <div style={{ height: 'calc(100vh - 150px)' }} className="container d-flex justify-content-center">
                            <LoaderComp color={'black'} />
                        </div>
                        :
                        this.state.hasProperOrgId ?
                            <div className="container custom-container my-5" >

                                <div>
                                    <CommonBreadCrumb
                                        data={[
                                            {
                                                link: '/admin/app/dashboard',
                                                name: 'ADMIN'
                                            }, {
                                                link: '',
                                                name: 'CUSTOM EMAILS'
                                            }
                                        ]}
                                    />
                                </div>
                                <div className="d-flex flex-row flex-wrap align-items-center">
                                    <div className="col-md-6 col-12 px-0 my-2">
                                        <div className="d-flex flex-row justify-content-md-around justify-content-between">
                                            <span className="col-4 mt-2" > Organisation &nbsp;
                                                {
                                                    loading &&
                                                    <i className="fas fa-spinner fa-spin text-black spinner-position" ></i>
                                                }
                                            </span>

                                            <Input
                                                value={this.state.orgId}
                                                type="select" name="field"
                                                bsSize="sm" className="col-6 border-1"
                                                onChange={this.onChangeOrganisation}
                                            >
                                                <option value='null' key={0}>Select Organization</option>;
                                                {
                                                    !loading &&
                                                    organisationResponse.map((organisation) => (
                                                        <option
                                                            value={organisation.id}
                                                            key={organisation.id}
                                                        >
                                                            {organisation.organisation_name}
                                                        </option>
                                                    ))
                                                }
                                            </Input>
                                        </div>
                                    </div>
                                    {
                                        this.state.showTable === true &&
                                        <Aux>
                                            <div className="col-md-4 col-8 px-0 my-2">
                                                <div className="d-flex flex-row justify-content-md-around justify-content-between">
                                                    <label className="col-3 mt-2" > Batch</label>
                                                    <Input
                                                        value={this.state.BatchId}
                                                        type="select" name="field"
                                                        bsSize="sm" className="col-6 border-1"
                                                        onChange={this.onChangeBatch}
                                                    >
                                                        <option value={null} key={0}>Unalloted</option>;
                                                        {
                                                            !getBatchLoading &&
                                                            batchListResponse.map((batch) => (
                                                                <option
                                                                    value={batch.id}
                                                                    key={batch.id}
                                                                >
                                                                    {batch.batch_name}
                                                                </option>
                                                            ))
                                                        }
                                                    </Input>
                                                </div>
                                            </div>

                                        </Aux>
                                    }

                                </div>

                                {
                                    assessmentResponse.length === 0 &&
                                    <p className="quattrocentosans bold text-center text-uppercase py-5">No Data to Display</p>
                                }
                                {
                                    assessmentResponse.length !== 0 && this.state.showTable === true &&
                                    <React.Fragment>
                                        <div className="bg-green rounded-top position-relative mt-5 animation-fade-in">
                                            <p className="text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular"> ASSESSMENTS </p>
                                        </div>
                                        {
                                            this.state.reRenderSettingsHead === 1 || this.state.reRenderSettingsHead === 2 ?
                                                <SettingsHead
                                                    buttonData={
                                                        this.state.buttonAssessmentData
                                                    }
                                                    secondColumn={false}

                                                    columns={settingsColumns}


                                                    sellers={[...assessmentResponse]}

                                                    view={this.filterData.bind(this)}

                                                    modal={this.toggleModal.bind(this)}
                                                    showModal={false}
                                                    filter="true"
                                                    widthClass={'col-md-6'}
                                                />

                                                :
                                                null
                                        }
                                        <CustomTableNew
                                            data={this.state.assessmentData}
                                            columns={columns}
                                            showSlNo="true"
                                            checkbox="true"
                                            selectCheckBox={this.selectAllAssessment.bind(this)}
                                            getData={this.getSelectedData.bind(this)}
                                            CheckKey={"idString"}
                                            sortBy={(key) => this.sortBy(key, !this.state.sortTypeAssessment, 'assessmentDataTable')}
                                            sortType={this.state.sortTypeAssessment}
                                        />
                                        {
                                            this.state.sendRemainderState &&
                                            <Modal
                                                isOpen={this.state.sendRemainderState}
                                                centered={this.state.centered}
                                                style={{ maxWidth: '600px' }}
                                            >
                                                <ModalHeader
                                                    toggle={this.toggle}
                                                    className="bg-black text-white text-uppercase custom-header"
                                                >
                                                    SEND REMINDER
                                                </ModalHeader>
                                                <ModalBody >
                                                    {remainderModalBody}
                                                </ModalBody>
                                                <ModalFooter style={{ margin: "auto" }} >

                                                    <Button color=" btn-sm text-white bg-secondary" onClick={this.toggle} ><small> CANCEL</small></Button>
                                                    {
                                                        this.alreadySubmitted(this.state.checkBoxData) &&
                                                        <button onClick={this.onClickSendRemainder} className="btn-red btn-sm " type="submit"><small>SEND MAIL</small></button>

                                                    }
                                                </ModalFooter>
                                            </Modal>

                                        }

                                        {
                                            this.state.sendMailState &&
                                            <Modal
                                                isOpen={this.state.sendMailState}
                                                centered={this.state.centered}
                                                style={{ maxWidth: '600px' }}
                                            >
                                                <ModalHeader
                                                    toggle={this.toggle}
                                                    className="bg-black text-white text-uppercase custom-header"
                                                >
                                                    SEND CUSTOM MAIL
                                                </ModalHeader>
                                                <ModalBody>
                                                    <p className="mt-4 text-center">This email will be sent to {this.state.checkBoxData.length} participant(s)</p>
                                                    <div className="">
                                                        <form >
                                                            <div className="form-group">
                                                                <div className="d-flex flex-row flex-wrap justify-content-between">
                                                                    <div className=" pt-2 h6  pl-md-3 pl-0 col-4 ">
                                                                        Template
                                                                    </div>
                                                                    <div className=" pl-0 pr-md-3 pr-0 col-8 ">
                                                                        <Input
                                                                            className="form-control"
                                                                            type={"select"}
                                                                            name={"template"}
                                                                            id="template"
                                                                            value={template}
                                                                            onChange={this.handleChange}
                                                                        >
                                                                            <option value={''}>Choose Template</option>
                                                                            <option value={'temp1'}>Template - 1</option>
                                                                            <option value={'temp2'}>Template - 2</option>

                                                                        </Input>
                                                                    </div>
                                                                </div>

                                                            </div>

                                                            <div className="form-group">
                                                                {submitted && subject.trim().length === 0 &&
                                                                    <div className="text-danger text-right">*Subject is required</div>
                                                                }
                                                                <div className="d-flex flex-row flex-wrap justify-content-between">
                                                                    <div className="pt-2 h6 pl-md-3 pl-0 col-4">
                                                                        Subject
                                                                        {' '}
                                                                        <span className="text-danger">*</span>
                                                                    </div>
                                                                    <div className=" pl-0 pr-md-3 pr-0 col-8 ">
                                                                        <Input
                                                                            className="form-control"
                                                                            type={"text"}
                                                                            name={"subject"}
                                                                            id="subject"
                                                                            placeholder={this.state.subjectPlaceholder}
                                                                            value={subject}
                                                                            onChange={this.handleChange}
                                                                        >
                                                                        </Input>


                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="form-group">
                                                                {submitted && message.trim().length === 0 &&
                                                                    <div className="text-danger text-right">*Message is required</div>
                                                                }
                                                                <div className="d-flex flex-row flex-wrap justify-content-between">

                                                                    <div className="pt-2 h6 pl-md-3 pl-0 col-4">
                                                                        Message
                                                                        {' '}
                                                                        <span className="text-danger">*</span>
                                                                    </div>
                                                                    <div className=" pl-0 pr-md-3 pr-0 col-8 ">
                                                                        <Input
                                                                            className="form-control"
                                                                            type={"textarea"}
                                                                            name={"message"}
                                                                            id="message"
                                                                            placeholder={this.state.messagePlaceholder}
                                                                            value={message}
                                                                            onChange={this.handleChange}
                                                                        >
                                                                        </Input>


                                                                    </div>
                                                                </div>

                                                            </div>


                                                        </form>
                                                    </div>
                                                </ModalBody>
                                                <ModalFooter style={{ margin: "auto" }} >

                                                    <Button color=" btn-sm text-white bg-secondary" onClick={this.toggle} ><small> CANCEL</small></Button>
                                                    {
                                                        <button onClick={this.handleSubmit} className="btn-red btn-sm " type="submit"><small>SEND MAIL</small></button>
                                                    }
                                                </ModalFooter>
                                            </Modal>

                                        }
                                    </React.Fragment>

                                }
                            </div>
                            :
                            <Page404 />
                }

            </ div >
        )
    }
}

CustomEmails.propTypes = {
    dispatch: PropTypes.func.isRequired,
    assessmentResponse: PropTypes.array.isRequired,
    location: PropTypes.object.isRequired,
    organisationResponse: PropTypes.array.isRequired,
    // Add other props used in the component
    loading: PropTypes.bool.isRequired,
    getBatchLoading: PropTypes.bool.isRequired,
    batchListResponse: PropTypes.array,

    history: PropTypes.object.isRequired,
};


function mapStateToProps(state) {

    const { loading, } = state.organisation;
    const organisationError = state.organisation.error;
    const organisationResponse = (!loading && !organisationError) ? state.organisation.organisation.data.organisation_list : '';

    const { getBatchLoading, } = state.getBatchAssessmentSummary;
    const getBatchAssessmentSummaryError = state.getBatchAssessmentSummary.error;
    const batchListResponse = (!getBatchLoading && !getBatchAssessmentSummaryError) ? state.getBatchAssessmentSummary.data.data.organisation_batch_list : '';

    const { getAssessmentLoading, } = state.getAssessmentSummary;
    const getAssessmentSummaryError = state.getAssessmentSummary.error;
    const assessmentResponse = (!getAssessmentLoading && !getAssessmentSummaryError) ? state.getAssessmentSummary.data.data.response : '';

    return {
        loading,
        organisationResponse,

        getBatchLoading,
        batchListResponse,

        getAssessmentLoading,
        assessmentResponse,
    }
}

export default connect(mapStateToProps)(CustomEmails);



// WEBPACK FOOTER //
// ./src/_pages/Admin/CustomEmails/index.jsx